import { Helmet } from 'react-helmet-async'
import { useT } from '../lib/i18n'
import Button from '../components/ui/Button'

export default function NotFound() {
  const t = useT()
  return (
    <>
      <Helmet>
        <title>404 — {t('brand.name')}</title>
      </Helmet>
      <section className="min-h-[60vh] flex items-center justify-center py-20">
        <div className="container-x text-center">
          <h1 className="font-display text-7xl md:text-9xl font-bold text-white mb-4">
            {t('notFound.title')}
          </h1>
          <p className="text-[var(--color-ink-muted)] text-lg mb-10">{t('notFound.message')}</p>
          <Button to="/" variant="primary" size="lg">
            {t('notFound.home')}
          </Button>
        </div>
      </section>
    </>
  )
}
